'use client';
import { ProspectsModal } from '@/components/modal';
import { ProspectsToast } from '@/components/toast';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { FloatingWhatsApp, theme } from '@repo/ui';
import { SendNavigatorData } from '@repo/utils';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { store } from './store';

export function Providers({ children, nonce }: { children: React.ReactNode; nonce: string }) {
  useEffect(() => {
    SendNavigatorData({
      app: 'prospects',
    });
  }, []);
  return (
    <ThemeProvider theme={theme({ nonce })}>
      <CssBaseline />
      <Provider store={store}>
        <ProspectsModal />
        <ProspectsToast />
        {children}
        <FloatingWhatsApp
          enable
          buttonTitle="¿Tenés dudas?"
          buttonSubtitle="Atención a comercios​"
          phoneNumber="5491157494024"
        />
      </Provider>
    </ThemeProvider>
  );
}
